export const resources = {
  articles: [
    {
      title: 'The Feynman Lectures on Physics',
      description: 'A timeless collection of lectures by Richard Feynman.',
      link: 'https://www.feynmanlectures.caltech.edu/',
      type: 'web'
    },
    {
      title: 'Gravitational Waves Detected 100 Years After Einstein\'s Prediction',
      description: 'The landmark paper from the LIGO collaboration.',
      link: 'https://journals.aps.org/prl/abstract/10.1103/PhysRevLett.116.061102',
      type: 'pdf'
    },
    {
      title: 'IBM Quantum Learning',
      description: 'Kickstart your quantum learning journey with a selection of courses designed to help you learn the basics or explore more focused topics. If you’re an instructor, explore content specifically tailored to incorporating quantum in the classroom.',
      link: 'https://quantum.cloud.ibm.com/learning/en',
      type: 'web'
    },
    {
      title: 'Quanta Magazine | Physics',
      description: 'In-depth, beautifully written articles on the latest research in fundamental physics and more.',
      link: 'https://www.quantamagazine.org/physics/',
      type: 'web'
    },
    {
      title: 'Symmetry Magazine',
      description: 'A joint Fermilab/SLAC publication about particle physics and its connections to life and the universe.',
      link: 'https://www.symmetrymagazine.org/',
      type: 'web'
    },
    {
      title: 'Physics Today',
      description: 'The flagship publication of the American Institute of Physics, covering news and research.',
      link: 'https://physicstoday.scitation.org/',
      type: 'web'
    },
    {
      title: 'arXiv.org | Physics',
      description: 'The definitive open-access archive for pre-print research papers in physics and related fields.',
      link: 'https://arxiv.org/archive/physics',
      type: 'pdf'
    },
    {
      title: 'HyperPhysics Concepts',
      description: 'An educational resource that uses concept maps to navigate a wide range of physics topics.',
      link: 'http://hyperphysics.phy-astr.gsu.edu/hbase/index.html',
      type: 'web'
    },
  ],

  videos: [
    {
      title: 'Something strange happens when you trust Quantum Mechanics',
      videoId: 'qJZ1Ez28C-A'
    },
    {
      title: 'I finally find least action principle satisfying-Mathemaniac',
      videoId: 'Ohrl3S2wcBU'
    },
    {
      title: 'The Fourth Dimension by Carl Sagan',
      videoId: 'UnURElCzGc0'
    },
    {
      title: 'Maxwell, Divergence and Fields',
      videoId: 'rB83DpBJQsE'
    }
  ]
};
